import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/pages/page-home/page-home.vue'
import dashboard from '@/components/pages/main-pages/dashboard/dashboard.vue'
import dashboardDraft from '@/components/pages/main-pages/dashboard-draft/dashboard-draft.vue'
import competitionsOverview from '@/components/pages/main-pages/competitions-overview/competitions-overview.vue'
import pageLogin from '@/components/pages/page-login/page-login.vue'
import pageSaml from '@/components/pages/page-saml/page-saml.vue'
import pageSamlLoading from '@/components/pages/page-saml-loading/page-saml-loading.vue'
import pageSamlError from '@/components/pages/page-saml-error/page-saml-error.vue'
import mainPages from '@/components/pages/main-pages/main-pages.vue'
import pageTemplates from '@/components/pages/page-templates/page-templates.vue'
import createCompetition from '@/components/pages/page-templates/create-update-competition/create-competition/create-competition.vue'
import editCompetition from '@/components/pages/page-templates/create-update-competition/edit-competition/edit-competition.vue'
import userManagement from '@/components/pages/main-pages/user-management/user-management.vue'
import userList from '@/components/pages/main-pages/user-management/user-list/user-list.vue'
import userProfile from '@/components/pages/main-pages/user-profile/user-profile.vue'
import userAdd from '@/components/pages/main-pages/user-management/user-add/user-add.vue'
import notAuthorized from '@/components/pages/not-authorized/not-authorized.vue'
import errorPage from '@/components/pages/error-page/error-page.vue'
import settings from '@/components/pages/main-pages/settings/settings.vue'
import store from '@/store'
import attributes from '@/components/pages/main-pages/settings/attributes/attributes.vue'
import attributesList from '@/components/pages/main-pages/settings/attributes/attributes-list/attributes-list.vue'
import attributeAdd from '@/components/pages/main-pages/settings/attributes/attribute-add/attribute-add.vue'
import attributeEdit from '@/components/pages/main-pages/settings/attributes/attribute-edit/attribute-edit.vue'
import optionAdd from '@/components/pages/main-pages/settings/attributes/option-add/option-add.vue'
import templatesSettings from '@/components/pages/main-pages/settings/templates/templates.vue'
import templatesSettingsList from '@/components/pages/main-pages/settings/templates/templates-list/templates-list.vue'
import templateAdd from '@/components/pages/main-pages/settings/templates/template-add/template-add.vue'
import tags from '@/components/pages/main-pages/settings/tags/tags.vue'
import tagsList from '@/components/pages/main-pages/settings/tags/tags-list/tags-list.vue'
import tagAdd from '@/components/pages/main-pages/settings/tags/tag-add/tag-add.vue'
import workflows from '@/components/pages/main-pages/settings/workflows/workflows.vue'
import workflowAdd from '@/components/pages/main-pages/settings/workflows/workflow-add/workflow-add.vue'
import workflowEdit from '@/components/pages/main-pages/settings/workflows/workflow-edit/workflow-edit.vue'
import workflowsList from '@/components/pages/main-pages/settings/workflows/workflows-list/workflows-list.vue'
import gdpr from '@/components/pages/main-pages/settings/gdpr/gdpr.vue'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    if (err.name != 'NavigationDuplicated') {
      throw err
    }
  })
}

Vue.use(Router)

const RouterInstance = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  },
  routes: [
    {
      name: 'dont-require-auth',
      path: '/dont-require-auth',
      component: home,
      meta: {
        requiresAuth: false
      }
    },
    {
      name: 'home',
      path: '/',
      component: home,
      meta: {
        requiresAuth: true
      }
    },
    {
      name: 'saml-flow',
      path: '/saml',
      component: pageSaml,
      children: [
        {
          name: 'saml-error',
          path: 'error',
          component: pageSamlError,
          meta: {
            requiresAuth: false
          }
        },
        {
          name: 'saml-loading',
          path: 'login-pending',
          component: pageSamlLoading,
          meta: {
            requiresAuth: false
          }
        }
      ]
    },
    {
      name: 'login',
      path: '/login',
      component: pageLogin,
      meta: {
        requiresAuth: false
      }
    },
    {
      name: 'main-pages',
      path: '/main-pages',
      component: mainPages,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          name: 'dashboard',
          path: '/dashboard',
          component: dashboard,
          meta: {
            requiresAuth: true
          },
          props: { type: 'active' }
        },
        {
          name: 'dashboard-draft',
          path: '/dashboard-draft',
          component: dashboardDraft,
          meta: {
            requiresAuth: true
          }
        },
        {
          name: 'competitions-overview',
          path: '/competitions-overview',
          component: competitionsOverview,
          meta: {
            requiresAuth: true,
            requiresAdmin: true
          }
        },
        {
          name: 'dashboard-archived',
          path: '/dashboard-archived',
          component: dashboard,
          meta: {
            requiresAuth: true
          },
          props: { type: 'closed' }
        },
        {
          name: 'user-profile',
          path: '/user-profile',
          component: userProfile,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/user-management',
          component: userManagement,
          meta: {
            requiresAdmin: true,
            requiresAuth: true
          },
          children: [
            {
              path: '/',
              name: 'user-management',
              component: userList,
              meta: {
                requiresAuth: true
              }
            },
            {
              name: 'user-add',
              path: '/user-add',
              component: userAdd,
              meta: {
                requiresAuth: true,
                requiresAdmin: true
              }
            }
          ]
        },
        {
          name: 'settings',
          path: '/settings',
          component: settings,
          meta: {
            requiresAuth: true
          },
          children: [
            {
              path: 'attributes',
              component: attributes,
              meta: {
                requiresAdmin: true,
                requiresAuth: true
              },
              children: [
                {
                  path: '',
                  name: 'attributes',
                  component: attributesList,
                  meta: {
                    requiresAuth: true,
                    requiresAdmin: true
                  }
                },
                {
                  name: 'attribute-add',
                  path: 'attribute-add',
                  component: attributeAdd,
                  meta: {
                    requiresAuth: true,
                    requiresAdmin: true
                  }
                },
                {
                  name: 'option-add',
                  path: 'option-add',
                  component: optionAdd,
                  meta: {
                    requiresAuth: true,
                    requiresAdmin: true
                  }
                },
                {
                  name: 'attribute-edit',
                  path: 'attribute-edit',
                  component: attributeEdit,
                  meta: {
                    requiresAuth: true,
                    requiresAdmin: true
                  }
                }
              ]
            },
            {
              path: 'templates',
              component: templatesSettings,
              meta: {
                requiresSuperAdmin: true,
                requiresAuth: true
              },
              children: [
                {
                  path: '',
                  name: 'templates',
                  component: templatesSettingsList,
                  meta: {
                    requiresAuth: true,
                    requiresAdmin: true
                  }
                },
                {
                  name: 'template-add',
                  path: 'template-add',
                  component: templateAdd,
                  meta: {
                    requiresAuth: true,
                    requiresAdmin: true
                  }
                }
              ]
            },
            {
              path: 'tags',
              name: '',
              component: tags,
              meta: {
                requiresSuperAdmin: true,
                requiresAuth: true
              },
              children: [
                {
                  path: '',
                  name: 'tags',
                  component: tagsList
                },
                {
                  name: 'tag-add',
                  path: 'tag-add',
                  component: tagAdd
                }
              ]
            },
            {
              path: 'workflows',
              component: workflows,
              meta: {
                requiresSuperAdmin: true,
                requiresAuth: true
              },
              children: [
                {
                  path: '',
                  name: 'workflows',
                  component: workflowsList
                },
                {
                  path: 'workflow-edit',
                  name: 'workflow-edit',
                  component: workflowEdit
                },
                {
                  path: 'workflow-add',
                  name: 'workflow-add',
                  component: workflowAdd
                }
              ]
            },
            {
              path: 'gdpr',
              component: gdpr,
              meta: {
                requiresSuperAdmin: true,
                requiresAuth: true
              },
              children: [
                {
                  path: '',
                  name: 'gdpr',
                  component: workflowsList
                }
              ]
            }
          ]
        }
      ]
    },
    {
      name: 'page-templates',
      path: '/page-templates',
      component: pageTemplates,
      meta: {
        requiresAuth: true
      }
    },
    {
      name: 'create-competition',
      path: '/create-competition',
      component: createCompetition,
      meta: {
        requiresAuth: true
      }
    },
    {
      name: 'edit-competition',
      path: '/edit-competition',
      component: editCompetition,
      meta: {
        requiresAuth: true
      }
    },
    {
      name: 'not-authorized',
      path: '/not-authorized',
      component: notAuthorized,
      meta: {
        requiresAuth: false
      }
    },
    {
      name: 'error-page',
      path: '/error-page',
      component: errorPage,
      meta: {
        requiresAuth: false
      }
    }
  ]
})

RouterInstance.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)
  const requiresAdmin = to.matched.some((record) => record.meta.requiresAdmin)
  const requiresSuperAdmin = to.matched.some((record) => record.meta.requiresSuperAdmin)
  const isSignedIn = store.getters['user/isSignedIn']
  const isAdmin = store.getters['user/isAdmin']
  const isSuperAdmin = store.getters['user/isSuperAdmin']
  if (requiresAuth && !isSignedIn) {
    return next({ name: 'login' })
  }
  if (requiresAdmin && !isAdmin) {
    return next({ name: 'not-authorized' })
  }
  if (requiresSuperAdmin && !isSuperAdmin) {
    return next({ name: 'not-authorized' })
  }
  next()
})

export default RouterInstance



// WEBPACK FOOTER //
// ./src/router/index.js